import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import './index.css';
import { App } from './App';
import { IS_DEV } from './config';

if (!IS_DEV) {
  Sentry.init({
    dsn: 'https://e1c194f6b77edfe1a4e68996088e13a1@o4505788935897088.ingest.sentry.io/4505788988653568',
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ['localhost', /.+embedgames.+/],
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);
